import { merge } from 'lodash';

export interface IPaymentSchema {
  couponout?: number;
  creditreceipt?: number;
  creditreceiptin?: number;
  pin?: number;
  cash?: number;
  withdrawel?: number;
  storecreditin?: number;
  change?: number;
  couponin?: number;
  creditcard?: number;
  consignment?: number;
  storecredit?: number;
}

/**
 * Model for eos
 */
export class EosModel {
  active?: boolean;
  _id?: string;
  shop?: {
    id: string;
    name: string;
  };
  cashier: {
    id?: string;
    name?: string;
    title?: string;
  };
  difference?: number;
  cashInDrawer?: { qty: number; value: number }[];
  original?: IPaymentSchema;
  final?: IPaymentSchema;
  periodStart?: Date;
  periodEnd?: Date;
  cycleID?: string;
  shift?: string;
  status: 'generated' | 'completed' | 'rectification';
  turnover: number;
  openingBalance: number;
  endBalance: number;
  totalCashInDrawer: number;
  expectedCashInDrawer: number;
  deposit: number;
  edited: boolean;
  remarks: string;
  vat?: { highAmount?: number; lowAmount?: number; zeroAmount?: number };

  constructor(originalValue?: Partial<EosModel>) {
    merge(
      this,
      {
        status: 'generated',
        original: {},
        final: {},
        difference: 0,
        turnover: 0,
        openingBalance: 0,
        endBalance: 0,
        totalCashInDrawer: 0,
        expectedCashInDrawer: 0,
        deposit: 0,
        cashier: {},
        edited: false,
      },
      originalValue,
    );
  }
}

// Hack! It makes sure that in the test scripts & test are using the same
// reference to the class
export const EosModelProvider = {
  provide: 'EosModel',
  useValue: EosModel,
};
